/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transfer_Dialog_No_ProjectsInputs */



/**
* | output |
* | --- |
* | "No other projects found." |
*
* @param {Transfer_Dialog_No_ProjectsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const transfer_dialog_no_projects = /** @type {((inputs?: Transfer_Dialog_No_ProjectsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transfer_Dialog_No_ProjectsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine anderen Projekte gefunden.")
	return /** @type {LocalizedString} */ ("No other projects found.")
});